/* cf-price-capture.js — 7 Oct 2026; 26 Oct: "Email me my plan", marketing tick, source question (Pete approved) (Pete: "put together all the fixes").
   Why: the leak inspection (30 days to 7 Oct) found 225 of 247 people who got a calculator price left
   without giving us any way to reach them; 128 had spent 2+ minutes building their fence. The only
   "email me this quote" route was on the review page, through the contact form.
   What: a short box right under the price (#quote-breakdown) on all four calculators. Name, email,
   optional phone. It posts to the same worker /enquiry route the quote page uses, so the CRM gets the
   contact, the parts list and the total (click-quote-intake), the team is notified and the customer
   gets the "We have your fence design" acknowledgement. The calc analytics already count /enquiry
   calls as enquiry_submitted, so the effect shows in the funnel.
   Wording lives in TEXT below and is customer-facing: Pete approves every word before this goes live.
   NOT cf-quote-capture.js: that live asset (Google Ads conversions + the review-page 'Send this quote to us'
   button) is a different thing. This one fills the gap on the step where the price first appears.
   Nothing here changes a price, the cart or the calculator. Remove the meta-tags line to roll back. */
(function () {
  'use strict';
  if (window.__cfPriceCapture) return;
  window.__cfPriceCapture = true;

  var TEXT = {
    /* 26 Oct 2026 (Pete: "plan capture wording approved, build it"): heading, line, button, tick and question approved. */
    heading: 'Email me my plan',
    sub: 'We’ll email you your plan and price, and check it over for you.',
    consent: 'Yes, email me Click Fencing offers, pool-fence tips and product news. Unsubscribe any time.',
    heard: 'How did you hear about us?',
    heardOptions: ['Google search', 'Google Maps', 'Facebook Marketplace', 'Facebook or Instagram', 'Friend or family', 'ChatGPT or AI', 'Builder or trade', 'Other'],
    name: 'Your name',
    email: 'Email',
    phone: 'Phone (optional)',
    button: 'Email me my plan',
    sending: 'Sending…',
    done: 'Done. We have your quote. Check your inbox, and your junk folder just in case.',
    failed: 'That didn’t go through. Please try again, or call us on 0497 701 834.',
    call: 'Prefer to talk? Call 0497 701 834.'
  };

  var CALCS = {
    '/pages/glass-fencing': 'Frameless',
    '/pages/blade-fence-calculator': 'Blade',
    '/pages/flat-top-fence-calculator': 'FlatTop',
    '/pages/perfmesh-fence': 'PerfMesh'
  };
  var path = (location.pathname || '/').replace(/\/+$/, '');
  var CALC = CALCS[path];
  if (!CALC) return;
  var WORKER = 'https://clickfencing-crm-api.ppfencing2.workers.dev/enquiry';
  /* 26 Oct 2026: the marketing tick (unticked by default) and the source answer go to the CRM store
     marketing_consents through public.click_capture_consent (publishable key; the table itself is private). */
  var CONSENT_RPC = 'https://mhzmtafzxeshqqtktbwh.supabase.co/rest/v1/rpc/click_capture_consent';
  var PUB_KEY = 'sb_publishable_2ZoKVLWLV2RhTHWljVqF9Q_alntcOKo';
  /* 26 Oct 2026 (Pete OK'd, Click ad review): the 7 Meta Lead events on 24 Oct were 7 test sends of this box
     (zzpetest@example.com, one browser), credited by view-through to an ad with 0 clicks. A test entry still
     reaches the CRM but does not fire the pixel, and one browser fires at most one Lead a day (a customer who
     re-sends a changed design counts once). The test rule mirrors the CRM's is_test_contact(). */
  function isTestLead(n, e) {
    n = String(n || '').trim().toLowerCase(); e = String(e || '').trim().toLowerCase();
    return /^zz|test/.test(n) || /^zz|\+zz|test/.test(e) ||
      /@(example\.(com|org|net)|clickfencing\.com\.au|ppfencing\.com\.au|pplandscaping\.com\.au)$/.test(e);
  }
  function firstLeadToday() {
    try { var k = 'cfqc-lead-' + new Date().toISOString().slice(0, 10); if (localStorage.getItem(k)) return false; localStorage.setItem(k, '1'); } catch (e) {}
    return true;
  }
  /* The ONE copy of "each section as the calculator saves it" (see fullSection below). cf-plan-autosave.js reads
     it at save time, so the autosaved design (calculator_plan_drafts, the Desk's "latest design") carries the
     same layout. Looked up at call time, so the load order of the two files does not matter. */
  window.CF_PLAN_LAYOUT = { version: 1, calculator: CALC, sections: function () { return readSections(); } };

  function money(s) {
    var m = String(s || '').replace(/[, ]/g, '').match(/\$?([0-9]+(?:\.[0-9]{1,2})?)/);
    return m ? parseFloat(m[1]) : 0;
  }

  function readTotal(box) {
    var lines = (box.innerText || '').split('\n').map(function (l) { return l.trim(); });
    for (var i = lines.length - 1; i >= 0; i--) {
      if (/^total$/i.test(lines[i]) && lines[i + 1]) return money(lines[i + 1]);
      var m = lines[i].match(/^total\s*:?\s*(\$[\d,]+(?:\.\d{2})?)/i);
      if (m) return money(m[1]);
    }
    var all = (box.innerText || '').match(/\$[\d,]+(?:\.\d{2})?/g);
    return all ? money(all[all.length - 1]) : 0;
  }

  function readLines(box) {
    var out = [], cat = 'Parts';
    var nodes = box.querySelectorAll('.breakdown-item, .breakdown-section > div');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (!n.classList.contains('breakdown-item')) {
        var t = (n.innerText || '').trim();
        if (t && !/\$/.test(t) && t.length < 40) cat = t;
        continue;
      }
      if (!n.offsetParent) continue;
      var nameEl = n.querySelector('.item-name');
      var qtyEl = n.querySelector('.item-quantity');
      var text = n.innerText || '';
      var sku = (text.match(/SKU:\s*([A-Za-z0-9\-]+)/) || [])[1] || null;
      var prices = text.match(/\$[\d,]+(?:\.\d{2})?/g) || [];
      var qty = qtyEl ? parseFloat((qtyEl.innerText || '').replace(/[^\d.]/g, '')) || 1 : 1;
      var line = prices.length ? money(prices[prices.length - 1]) : 0;
      var each = /each/i.test(text) && prices.length > 1 ? money(prices[0]) : (qty ? line / qty : line);
      out.push({
        category: cat,
        item: nameEl ? (nameEl.innerText || '').trim() : text.split('\n')[0].trim(),
        sku: sku, quantity: qty, unitPrice: each, totalPrice: line
      });
    }
    return out.slice(0, 120);
  }

  /* 24 Oct 2026 (Pete: "fix the perfmesh calculator $99 and parts list", Leanne's 43 m PerfMesh): on the
     Configure step the panel lists only the section on screen (cf-current-section-parts.js collapses the
     rest to "Other section (1) $x"), so readLines() sent 5 of 27 lines and the CRM could not quote it. The
     calculator's own state.quoteBreakdown is the WHOLE job, one line per part with its sku and variant id.
     Use it whenever it adds up to the Total on screen (to the cent); otherwise send what is on screen, as
     before. Never a number of our own. */
  function jobLines(screenTotal) {
    try {
      var bd = window.glassCalculator && window.glassCalculator.state && window.glassCalculator.state.quoteBreakdown;
      if (!Array.isArray(bd) || !bd.length) return null;
      var sum = 0, out = [];
      for (var i = 0; i < bd.length; i++) {
        var b = bd[i] || {};
        var tp = Number(b.totalPrice) || 0;
        sum += tp;
        out.push({
          category: b.category || 'Parts', item: String(b.item || ''), sku: b.sku || null,
          quantity: Number(b.quantity) || 1, unitPrice: Number(b.unitPrice) || 0, totalPrice: tp,
          variantId: b.variantId || null, section: b.section || null, colour: b.colour || null
        });
      }
      if (!(screenTotal > 0) || Math.abs(sum - screenTotal) > 0.011) return null;
      return out.slice(0, 200);
    } catch (e) { return null; }
  }

  /* 15 Oct 2026 (Pete, Desma Decke's enquiry: "how can we not see where the gate sits?"). This box used to
     send each section as { length, hasGate } only, so the CRM could not draw the fence or say where the gate
     is. It now sends the SAME section layout the calculator saves when the customer goes to the quote page
     (panels in order with widths, start gap, the gap or post after each panel, gate side and width), built
     the way each calculator's own save does it - the four are different programs. click-quote-intake draws
     the fence from it. If anything here fails, the old two-field summary still goes. */
  function fullSection(gc, k, s) {
    var n = parseInt(k, 10);
    var base = {
      num: n, length: s.length, colour: s.colour || s.color || '', hasGate: !!s.hasGate, hasRaked: !!s.hasRaked,
      hasClamp: !!s.hasClamp, gateLength: s.gateLength || null, hingeType: s.hingeType || null,
      latchType: s.latchType || null, latchColor: s.latchColor || null, panelLength: s.panelLength || null,
      gateSide: s.gateSide || 'right', rakedSide: s.rakedSide || 'left', endPostSetup: s.endPostSetup || null,
      gapSpacing: s.gapSpacing || null
    };
    try { if (typeof gc.colourDisplayLabel === 'function') base.colour = gc.colourDisplayLabel(s) || base.colour; } catch (e) {}
    var lay = null;
    try {
    if (CALC === 'FlatTop' || CALC === 'Blade') {
      // flat-top.js / blade.js proceedToQuotePage: { ..., ...this.buildSectionPanelData(s, sNum) }
      if (typeof gc.buildSectionPanelData === 'function') lay = gc.buildSectionPanelData(s, n);
    } else if (CALC === 'PerfMesh') {
      // perfmesh-calc.js addToCart: renderedPanels without 'hinge', a post (gapSpacing) after each, no post at a no-left/no-right end
      var panels = (s.renderedPanels || []).filter(function (p) { return p.type !== 'hinge'; });
      var post = parseInt(s.gapSpacing, 10) || 50;
      var ep = s.endPostSetup || 'both';
      var skipL = ep === 'no-left' || ep === 'no-both', skipR = ep === 'no-right' || ep === 'no-both';
      lay = { panels: panels, startGap: skipL ? 0 : post,
              trailingGaps: panels.map(function (_, i) { return i === panels.length - 1 && skipR ? 0 : post; }) };
    } else {
      // ullc-calc.js proceedToQuotePage
      var calc = gc.state.optimizedConfigs && gc.state.optimizedConfigs[n];
      if (calc && s.length) {
        var gp = s.customPanelOrder && s.customPanelOrder.length > 0
          ? gc.reconstructPanelsFromCustomOrder(s, calc)
          : gc.calculatePanelsLayout({
              calculation: calc, sectionLength: parseInt(s.length, 10), hasRaked: s.hasRaked || false,
              hasGate: s.hasGate || false,
              gateWidth: s.gateLength ? parseInt(s.gateLength, 10) : gc.getDefaultGateLength('soft-close'),
              rakedSide: s.rakedSide || 'left', retainedHeight: s.retainedHeight || 1500,
              hingeType: s.hingeType || 'soft-close', gateFlipped: s.gateFlipped || false,
              gateSide: s.gateSide || 'right', wallGateEnd: s.wallGateEnd || null,
              gateHingeType: s.gateHingeType || 'glass-to-glass'
            });
        lay = { panels: gp.map(function (p) { return { type: p.type, width: p.width }; }),
                trailingGaps: gc.buildTrailingGaps(gp, calc), startGap: gc.buildStartGap(calc, gp) };
      }
    }
    } catch (e) { lay = null; }   // this section goes as length + gate only; the others keep their layout
    /* The HINGE side, stated plainly. Glass, Blade and Flat Top store it as gateSide ("LHS Hinge" = 'left');
       PerfMesh stores the opposite ("LHS Hinge" = gateSide 'right') and marks the hinge side of the gate with a
       'hinge' entry in renderedPanels - checked by toggling the radio on the live page, 15 Oct. */
    try {
      var hs = null;
      if (CALC === 'PerfMesh') {
        var rp = s.renderedPanels || [], gi = -1;
        for (var q = 0; q < rp.length; q++) if (rp[q] && (rp[q].type === 'gate' || rp[q].isGate)) { gi = q; break; }
        if (gi > 0 && rp[gi - 1] && rp[gi - 1].type === 'hinge') hs = 'left';
        else if (gi >= 0 && rp[gi + 1] && rp[gi + 1].type === 'hinge') hs = 'right';
        else if (s.gateSide === 'left' || s.gateSide === 'right') hs = s.gateSide === 'left' ? 'right' : 'left';
      } else if (s.gateSide === 'left' || s.gateSide === 'right') {
        hs = s.gateSide;
      }
      if (s.hasGate && hs) base.hingeSide = hs;
    } catch (e) {}
    if (lay) {
      base.panels = (lay.panels || []).map(function (p) {
        return { type: p.type, width: p.width, isGate: !!p.isGate, isRaked: !!p.isRaked };
      });
      base.startGap = lay.startGap || 0;
      base.trailingGaps = lay.trailingGaps || [];
      if (lay.gateSide) base.gateSide = lay.gateSide;
      if (lay.rakedSide) base.rakedSide = lay.rakedSide;
    }
    return base;
  }

  function readSections() {
    var gc = window.glassCalculator, s = gc && gc.state && gc.state.sections;
    if (!s) return [];
    try {
      return Object.keys(s).filter(function (k) { return parseFloat(s[k].length) > 0; })
        .map(function (k) { return fullSection(gc, k, s[k]); });
    } catch (e) {
      try {
        return Object.keys(s).map(function (k) {
          return { length: parseFloat(s[k].length) || 0, hasGate: !!s[k].hasGate };
        }).filter(function (x) { return x.length > 0; });
      } catch (e2) { return []; }
    }
  }

  function pricingType() {
    try { return (window.glassCalculator.state.pricingType === 'install') ? 'install' : 'diy'; } catch (e) { return 'diy'; }
  }

  function ref() {
    var r;
    try { r = crypto.randomUUID().slice(0, 8); } catch (e) { r = Math.random().toString(36).slice(2, 10); }
    return 'CF-' + CALC.slice(0, 4).toUpperCase() + '-' + Date.now() + '-' + r;
  }

  var panel = null;
  function build() {
    panel = document.createElement('div');
    panel.id = 'cf-price-capture';
    panel.style.cssText = 'margin:14px 0 4px;padding:14px 16px;border:2px solid #c8102e;border-radius:10px;background:#fff;color:#1d2a2b;font-size:15px;line-height:1.45';
    panel.innerHTML =
      '<div style="font-weight:700;font-size:17px;margin:0 0 4px" data-t="heading"></div>' +
      '<div style="margin:0 0 10px;color:#4a5859;font-size:14px" data-t="sub"></div>' +
      '<form novalidate style="display:grid;gap:8px">' +
      '<input id="cfqc-name" name="name" autocomplete="name" required style="padding:10px 12px;border:1px solid #c9d1d1;border-radius:8px;font-size:16px">' +
      '<input id="cfqc-email" name="email" type="email" autocomplete="email" required style="padding:10px 12px;border:1px solid #c9d1d1;border-radius:8px;font-size:16px">' +
      '<input id="cfqc-phone" name="phone" type="tel" autocomplete="tel" style="padding:10px 12px;border:1px solid #c9d1d1;border-radius:8px;font-size:16px">' +
      '<select id="cfqc-heard" name="heard" style="padding:10px 12px;border:1px solid #c9d1d1;border-radius:8px;font-size:16px;background:#fff;color:#1d2a2b"></select>' +
      '<label for="cfqc-consent" style="display:flex;gap:8px;align-items:flex-start;font-size:14px;line-height:1.4;color:#1d2a2b;cursor:pointer"><input id="cfqc-consent" name="consent" type="checkbox" style="margin:2px 0 0;width:18px;height:18px;flex:0 0 auto"><span data-t="consent"></span></label>' +
      '<input id="cfqc-website" name="website" tabindex="-1" autocomplete="off" aria-hidden="true" style="position:absolute;left:-9999px;width:1px;height:1px">' +
      '<button type="submit" id="cfqc-send" style="padding:12px 16px;border:0;border-radius:8px;background:#c8102e;color:#fff;font-weight:700;font-size:16px;cursor:pointer"></button>' +
      '</form>' +
      '<div id="cfqc-msg" role="status" style="margin:8px 0 0;font-size:14px"></div>' +
      '<div style="margin:8px 0 0;font-size:13px;color:#4a5859" data-t="call"></div>';
    panel.querySelector('[data-t="heading"]').textContent = TEXT.heading;
    panel.querySelector('[data-t="sub"]').textContent = TEXT.sub;
    panel.querySelector('[data-t="call"]').textContent = TEXT.call;
    panel.querySelector('#cfqc-name').placeholder = TEXT.name;
    panel.querySelector('#cfqc-email').placeholder = TEXT.email;
    panel.querySelector('#cfqc-phone').placeholder = TEXT.phone;
    panel.querySelector('#cfqc-send').textContent = TEXT.button;
    panel.querySelector('[data-t="consent"]').textContent = TEXT.consent;
    var sel = panel.querySelector('#cfqc-heard');
    var o0 = document.createElement('option'); o0.value = ''; o0.textContent = TEXT.heard; sel.appendChild(o0);
    TEXT.heardOptions.forEach(function (h) { var op = document.createElement('option'); op.value = h; op.textContent = h; sel.appendChild(op); });
    panel.querySelector('form').addEventListener('submit', onSubmit);
  }

  var sending = false, sentFor = null;
  function onSubmit(ev) {
    ev.preventDefault();
    var box = document.getElementById('quote-breakdown');
    var msg = panel.querySelector('#cfqc-msg');
    var name = panel.querySelector('#cfqc-name').value.trim();
    var email = panel.querySelector('#cfqc-email').value.trim();
    var phone = panel.querySelector('#cfqc-phone').value.trim();
    if (panel.querySelector('#cfqc-website').value) return; // bots fill the hidden box
    if (!name) { panel.querySelector('#cfqc-name').focus(); return; }
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { panel.querySelector('#cfqc-email').focus(); return; }
    if (sending || !box) return;
    var total = readTotal(box);
    if (sentFor === email + '|' + total) { msg.textContent = TEXT.done; return; }
    sending = true;
    var btn = panel.querySelector('#cfqc-send');
    btn.disabled = true; btn.textContent = TEXT.sending; msg.textContent = '';
    var reference = ref();
    var body = {
      quote: {
        quoteName: 'Calculator quote', quoteNum: Date.now(), calcType: CALC, pricingType: pricingType(),
        grandTotal: total, currency: 'AUD', sections: readSections(), breakdown: jobLines(total) || readLines(box),
        generatedAt: new Date().toISOString(), diagramHtml: null,
        enquirySource: 'Email me my plan (calculator, beside the price)'
      },
      customer: { name: name, email: email, phone: phone, address: '', suburb: '', postcode: '' },
      quoteReference: reference, pdfBase64: null, pdfFileName: null
    };
    fetch(WORKER, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.ok; }, function () { return false; })
      .then(function (ok) {
        sending = false; btn.disabled = false; btn.textContent = TEXT.button;
        if (ok) { sentFor = email + '|' + total;
          try { fetch(CONSENT_RPC, { method: 'POST', headers: { 'Content-Type': 'application/json', apikey: PUB_KEY },
            body: JSON.stringify({ p_email: email, p_consent: !!panel.querySelector('#cfqc-consent').checked,
              p_heard: panel.querySelector('#cfqc-heard').value, p_ref: reference, p_page: path }) }).catch(function () {}); } catch (e) {} msg.style.color = '#1d6b3a'; msg.textContent = TEXT.done;
          // 7 Oct 2026 (Pete: "add lead event"): tell Meta a quote was emailed - only on a real send, deduped by eventID
          try { if (window.fbq && !isTestLead(name, email) && firstLeadToday()) window.fbq('track', 'Lead', { content_name: CALC + ' calculator quote', value: total, currency: 'AUD' }, { eventID: 'cfqc-' + reference }); } catch (e) {} }
        else { msg.style.color = '#c8102e'; msg.textContent = TEXT.failed; }
      });
  }

  function place() {
    try {
      var box = document.getElementById('quote-breakdown');
      var priced = box && box.offsetParent !== null && readTotal(box) > 0;
      if (!priced) { if (panel) panel.style.display = 'none'; return; }
      if (!panel) build();
      // Under the green "Instant Quote" total when it follows the breakdown, so the price reads first.
      var anchor = box;
      var nx = box.nextElementSibling;
      while (nx && nx === panel) nx = nx.nextElementSibling;
      if (nx && nx.classList && nx.classList.contains('quote-display')) anchor = nx;
      if (panel.previousElementSibling !== anchor) anchor.insertAdjacentElement('afterend', panel);
      panel.style.display = '';
    } catch (e) {}
  }

  var t = null;
  try {
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(place, 250); })
      .observe(document.body, { childList: true, subtree: true });
  } catch (e) {}
  setInterval(place, 2000);
  place();
  try { console.log('[cf-price-capture] installed for ' + CALC); } catch (e) {}
})();
